import React from 'react';
import Button from 'components/Button/Button';
import Buttonv2 from 'components/_v2/atoms/buttons/Button';
import { useExtension } from '../../../hooks/useExtension';

const SsoButton = ({ t, setUseSso }) => {
  const featureFlags = useExtension('FeatureFlags');
  const isPaas = featureFlags?.isPaas;

  if (isPaas) {
    return (
      <Button appearance="light" onClick={() => setUseSso(true)}>
        {t('connect-sso')}
      </Button>
    );
  }

  return (
    <Buttonv2 variant="kazaarSecondary" onClick={() => setUseSso(true)}>
      {t('connect-sso')}
    </Buttonv2>
  );
};

export default SsoButton;
